// constants

// components

// import Button from "../../../components/elements/form/Button";

// constants
import { constant } from "../../../constants/pages";

// import oil from "../../../assets/images/pages/oil.png";
// import incorporationimg from "../../../assets/images/pages/Manufacturing1.png";
// import people from "../../../assets/images/pages/Strength1.png";
// import handshake from "../../../assets/images/pages/Handshake.png";
// import { FaArrowRightLong } from "react-icons/fa6";

// react router dom
// import { useNavigate } from "react-router-dom";
import CarouselAutoPlay from "../../../components/ui/carousel";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import HeroHome from "../../../components/ui/HeroHome/HeroHome";
import WhyChooseUs from "../../../components/ui/WhyChooseUs";
import ServicesSection from "../../../components/ui/HomeServices/ServicesSection";

const Landing = () => {
  // const navigate = useNavigate();
  return (
    <AnimatedPage>
      <div className="w-full">
        {/* Hero Section Start */}
        <HeroHome />
        {/* Hero Section End */}

        {/* More about the service start */}
        <section className="bg-dark py-10">
          <div className="max-w-7xl mx-auto px-6 xl:px-0">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 xl:gap-12">
              <div className="lg:w-[40%] text-gray-600">
                <p className="text-2xl md:text-xl md:text-center lg:text-left font-bold !font-sans ">
                  We Set up Just As You Like It
                </p>
                <p className="text-sm md:text-base md:text-center lg:text-left">
                  Behold the power to set up your company from anywhere and
                  monitor its progress from anywhere.
                </p>
              </div>
              <div className="w-full lg:w-[60%]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {constant.landing.map((item, index) => (
                    <div key={index + 1} className="flex gap-3">
                      <img
                        loading="lazy"
                        className="size-7 xl:size-12"
                        src={item.icon}
                        alt={`${item.title} ${item.subtitle}`}
                        decoding="async"
                      />
                      <div className="flex flex-row md:flex-col text-gray-600">
                        <p className="text-lg md:text-2xl mr-3 md:mr-0">
                          {item.title}
                        </p>
                        <span className="text-lg md:text-sm">
                          {item.subtitle}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* More about the service end*/}

        {/* Why choose us section start */}
        <WhyChooseUs />
        {/* Why choose us section end */}

        {/* Services Section Start */}
        <ServicesSection />
        {/* Services Section End */}

        {/* Testimonial section */}
        <section className="bg-customyellow">
          <div className="max-w-7xl mx-auto px-6 xl:px-0 py-10 md:py-20">
            <CarouselAutoPlay items={constant.testimonials} />
          </div>
        </section>
        {/* Testimonial section */}
      </div>
    </AnimatedPage>
  );
};

export default Landing;
